import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text } from '../../Text';
import { ENTER_KEY, SPACE_KEYCODE } from '../../Utils/constant';
import { ActionListContext } from '../ActionList';
import moduleStyles from '@dtsl/css-action-list/dist/index.module.css';
function ActionListItem(props) {
  const {
    title,
    subText,
    icon,
    tag,
    id,
    isDestructive,
    disabled,
    onSelect
  } = props;
  const {
    setIsOpen
  } = useContext(ActionListContext);
  const actionListItemClasses = classNames({
    [moduleStyles['sib-action-list__item']]: true,
    [moduleStyles['sib-action-list__item--destructive']]: isDestructive,
    [moduleStyles['sib-action-list__item--disabled']]: disabled
  });
  const handleClick = event => {
    onSelect(event);
    setIsOpen(false);
  };
  const headingColor = isDestructive ? 'var(--sib-color_negative-hover)' : 'var(--sib-color_content-primary)';
  const iconFunc = icon();
  const tagFunc = tag();
  return /*#__PURE__*/React.createElement("li", {
    onKeyDown: event => {
      if ((event.key === ENTER_KEY || event.keyCode === SPACE_KEYCODE) && !disabled) {
        handleClick(event);
      }
    },
    className: actionListItemClasses,
    key: id,
    role: "menuitem"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    disabled: disabled
  }, iconFunc ? /*#__PURE__*/React.createElement("span", {
    className: moduleStyles['sib-action-list__item-icon']
  }, icon(headingColor)) : null, /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-action-list__item-text']
  }, /*#__PURE__*/React.createElement(Text, {
    size: "lg",
    tag: "div",
    color: headingColor,
    fontFamily: "interactive"
  }, title), subText && /*#__PURE__*/React.createElement(Text, {
    size: "sm",
    tag: "p",
    color: "var(--sib-color_content-secondary)"
  }, subText)), tagFunc ? /*#__PURE__*/React.createElement("span", {
    className: moduleStyles['sib-action-list__item-tag']
  }, tag()) : null));
}
ActionListItem.defaultProps = {
  title: '',
  subText: '',
  icon: () => {},
  tag: () => {},
  isDestructive: false,
  disabled: false,
  onSelect: () => {}
};
ActionListItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  subText: PropTypes.string,
  icon: PropTypes.func,
  tag: PropTypes.func,
  isDestructive: PropTypes.bool,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func
};
export default ActionListItem;